import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

/**
 * Why a dialog's save failed, shown between the scrolling content and the button row.
 *
 * It belongs there rather than inside `mat-dialog-content` because that region scrolls: on a tall
 * form the user submits from the pinned button row, and a message rendered next to the fields can
 * appear far above the fold, leaving the click looking like it did nothing. Here it is always in
 * view, next to the button that caused it.
 *
 * Renders nothing while `message` is `null`. It is a `role="alert"` so a screen reader announces
 * it the way it would a snack bar.
 */
@Component({
  selector: 'app-dialog-error-bar',
  imports: [MatIcon],
  templateUrl: './dialog-error-bar.html',
  host: {
    class: 'block',
  },
})
export class DialogErrorBar {
  readonly message = input.required<string | null>();
}
